import moment from "moment";
import dashboard from "../menu-items/dashboard";

// Patient table data conversion
export const convertSubjectData = (data) => {
  return data?.map((sub) => {
    let transformCode = sub?.subject_code;
    let transformedSubjectInitial = sub?.sub_initials;
    let transformeInvestigator = sub?.investigatorDetails?.name;
    let transformedEditor = sub?.editorDetails
      ? `${sub.editorDetails.name}`
      : "Not Assigned";
    return [
      transformCode,
      transformedSubjectInitial,
      transformeInvestigator,
      transformedEditor,
    ];
  });
};

export const checkForSubchild = (firstSegment) => {
  let isChild = null;
  for (let item of dashboard.children) {
    if (item?.subChildren) {
      for (let subItem of item.subChildren) {
        if (subItem.id === firstSegment) {
          isChild = subItem;
          isChild.parent = item.title;
          isChild.parentId = item.id;
          break;
        }
      }
    }
  }
  return isChild;
};

function isDarkColor(color) {
  const r = parseInt(color.substr(1, 2), 16);
  const g = parseInt(color.substr(3, 2), 16);
  const b = parseInt(color.substr(5, 2), 16);
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
  return brightness < 128;
}

const usedColors = new Set();

export function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color;

  do {
    color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
  } while (
    isDarkColor(color) ||
    color === "#000000" ||
    color === "#00008B" ||
    usedColors.has(color)
  );

  usedColors.add(color);
  return color;
}
const formatDate = (dateString) => {
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};

export function capitalizeFirstLetter(str) {
  if (!str) return "N/A"; // handle empty or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const convertToUpperCase = (str) => str ? str.toUpperCase() : "";

export function capitalizeWords(str) {
  if(!str) return ""
  return str?.toLowerCase()?.split(" ")?.map(word => word?.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const formatDateForApi = (date) => {
  if (!date) return null;

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;

  const pad = (n) => String(n).padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

export const formatDateMoment = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export const dateofBirthMoment = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
};
/*
export function formatDateMoment(date) {
  if (!date || !moment(date).isValid()) {
    return "-"; // Return 'N/A' if the date is invalid or missing
  }
  return moment.utc(date).format("DD/MM/YYYY"); // Format the date to 'dd/mm/yyyy'
}*/

// Helper function to get all unique questions

// Helper function to strip HTML tags from text
const stripHtmlTags = (text) => {
  if (!text) return '';
  return text.replace(/<[^>]*>/g, '').trim();
};

// Helper function to group data by patient
const groupDataByPatient = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    const patientKey = `${item.subject.patient_id}_${item.subject.first_name}_${item.subject.last_name}`;

    if (!groupedData[patientKey]) {
      groupedData[patientKey] = {
        subject: item.subject,
        appointments: []
      };
    }

    groupedData[patientKey].appointments.push(...item.appointment);
  });

  return Object.values(groupedData);
};


// Helper function to determine the highest approval status for a visit
const getDataReviewStatus = (approvedUsers) => {
  if (!approvedUsers || approvedUsers.length === 0) {
    return 'Data Entered';
  }

  const hasCPM = approvedUsers.some(user =>
    user.includes('Clinical Phase Manager')
  );
  if (hasCPM) {
    return 'Data Approved by CPM';
  }

  const hasDQA = approvedUsers.some(user =>
    user.includes('Quality Associate')
  );
  if (hasDQA) {
    return 'Data Approved by DQA';
  }

  const hasPI = approvedUsers.some(user =>
    user.includes('Principal Investigator')
  );
  if (hasPI) {
    return 'Data Approved by PI';
  }

  return 'Data Entered';
};

// Helper function to group appointments by visit type
const groupAppointmentsByVisitType = (appointments) => {
  const grouped = {};

  appointments.forEach((appointment) => {
    const visitType = appointment.form_title || 'Unknown';
    if (!grouped[visitType]) {
      grouped[visitType] = [];
    }
    grouped[visitType].push(appointment);
  });

  return grouped;
};

// Helper function to get questions by visit type
const getQuestionsByVisitType = (data) => {
  const questionsByVisit = {};

  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      const visitType = appointment.form_title || 'Unknown';
      if (!questionsByVisit[visitType]) {
        questionsByVisit[visitType] = new Set();
      }

      appointment.reports.forEach((report) => {
        questionsByVisit[visitType].add(stripHtmlTags(report.question));
      });
    });
  });

  Object.keys(questionsByVisit).forEach(visitType => {
    questionsByVisit[visitType] = Array.from(questionsByVisit[visitType]);
  });

  return questionsByVisit;
};

 export  const buildAssigneeList = (data) => {
  const list = [];
     if (data?.userPi?.length) {
    data.userPi.forEach((pi) => {
      list.push({
        id: pi.id,
        name: pi.name,
        role: pi.role_title,
      });
    });
  }
  return list;
};

export const getCurrentDateTime = (dateString ='') => {
  const date = dateString ?  new Date(dateString): new Date();
  
  // Use UTC methods to avoid timezone conversion
  const day = date.getUTCDate();
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getUTCFullYear();
  
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  
  hours = hours % 12;
  hours = hours ? hours : 12;
  
  return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
}

export const jsonToCsv = (data) => {
  const csvRows = [];

  const groupedData = groupDataByPatient(data);

  const staticHeaders = [
    'S.No.',
    'Patient ID',
    'First Name',
    'Last Name',
    'Patient Status',
    'Status Change'
  ];

  const allVisitTypes = new Set();
  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      if (appointment.form_title) {
        allVisitTypes.add(appointment.form_title);
      }
    });
  });
  const visitTypesArray = Array.from(allVisitTypes);

  const questionsByVisit = getQuestionsByVisitType(data);

  // Variable for For each visit type, add its questions + Data Review Status
  const dynamicHeaders = [];
  visitTypesArray.forEach(visitType => {
    const questions = questionsByVisit[visitType] || [];
    questions.forEach(question => {
      dynamicHeaders.push(question);
    });
    dynamicHeaders.push(`${visitType} - Data Review Status`);
  });

  const endingHeaders = [
    'Visit Types',
    'Appointment Titles',
    'Open Queries',
    'Pending Approval',
    'Approved',
  ];

  const allHeaders = [...staticHeaders, ...dynamicHeaders, ...endingHeaders];
  csvRows.push(allHeaders.map(header => `"${header}"`).join(','));

  let serialNumber = 1;

  // ForEach loop to Extract rows for one per patient
  groupedData.forEach((patientData) => {
    const staticData = [
      serialNumber++,
      patientData.subject.patient_id || "-",
      patientData.subject.first_name,
      patientData.subject.last_name,
      capitalizeFirstLetter(patientData.subject.life_status),
      formatDateMoment(patientData.subject.status_change_date)
    ];

    const appointmentsByVisit = groupAppointmentsByVisitType(patientData.appointments);

    const visitTypes = [];
    const appointmentTitles = [];
    const allQueries = [];
    const allPendingUsers = [];
    const allApprovedUsers = [];

    patientData.appointments.forEach((appointment) => {
      if (appointment.form_title) visitTypes.push(appointment.form_title);
      if (appointment.title) appointmentTitles.push(appointment.title);
      if (appointment.query_raised?.length > 0) allQueries.push(...appointment.query_raised);
      if (appointment.pending_users?.length > 0) allPendingUsers.push(...appointment.pending_users);
      if (appointment.approved_users?.length > 0) allApprovedUsers.push(...appointment.approved_users);
    });

    const dynamicData = [];
    
    visitTypesArray.forEach(visitType => {
      const questions = questionsByVisit[visitType] || [];
      const visitsOfType = appointmentsByVisit[visitType] || [];
      
      const answersForVisit = {};
      visitsOfType.forEach(appointment => {
        appointment.reports.forEach((report) => {
          const question = stripHtmlTags(report.question);
          let answer = report?.answer || '';

          // Conditional rendering to Format date answers
          if (typeof answer === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(answer)) {
            answer = formatDate(answer);
          }

          // Conditional rendering to Handle different answer types
          if (Array.isArray(answer)) {
            answer = answer.filter(Boolean).join(', ');
          } else if (answer === null || answer === "") {
            answer = '';
          } else {
            answer = String(answer).replace(/\n/g, ' ');
          }

          if (answer && answer.trim() !== '') {
            if (!answersForVisit[question]) {
              answersForVisit[question] = [];
            }
            answersForVisit[question].push(answer);
          }
        });
      });

      // FOrEach loop to Add answers for each question of this visit type
      questions.forEach(question => {
        const answers = answersForVisit[question] || [];
        const uniqueAnswers = [...new Set(answers)];
        dynamicData.push(uniqueAnswers.length > 0 ? `"${uniqueAnswers.join(' | ')}"` : '');
      });

      const allApprovedForVisit = [];
      visitsOfType.forEach(visit => {
        if (visit.approved_users?.length > 0) {
          allApprovedForVisit.push(...visit.approved_users);
        }
      });
      const status = getDataReviewStatus(allApprovedForVisit);
      dynamicData.push(`"${status}"`);
    });

    const endingData = [
      visitTypes.length > 0 ? `"${[...new Set(visitTypes)].join(' , ')}"` : 'N/A',
      appointmentTitles.length > 0 ? `"${[...new Set(appointmentTitles)].join(' , ')}"` : 'N/A',
      allQueries.length > 0 ? `"${[...new Set(allQueries)].join(' , ')}"` : 'N/A',
      allPendingUsers.length > 0 ? `"${[...new Set(allPendingUsers)].join(' , ')}"` : 'N/A',
      allApprovedUsers.length > 0 ? `"${[...new Set(allApprovedUsers)].join(' , ')}"` : 'N/A',
    ];

    csvRows.push([...staticData, ...dynamicData, ...endingData].join(','));
  });

  return csvRows.join("\n");
};


export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create a link element, set the download attribute, and trigger a click event
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export function checkValueIsDate(value) {
  const parsedDate = moment(value);
  if (parsedDate.isValid()) {
    return true;
  } else {
    return false;
  }
}

export function convertIntoTimeZone(value) {
  if (!value) return;
  const [day, month, year] = value.split("/").map(Number);
  // Create Date object using the extracted values (note: month is 0-based)
  const date = new Date(year, month - 1, day, 10, 7, 28); // set time to 10:07:28
  return date.toString();
}

export function getValueByPath(obj, path) {
  const parts = path.split('.'); // split by dot
  return parts.reduce((acc, part) => {
    if (acc === undefined || acc === null) return undefined;
        if (typeof acc === "string") {
      try {
        const parsed = JSON.parse(acc);
        acc = parsed;
      } catch {
         // ignore if not a JSON string
      }
    }
    // if part is a number, convert to integer (for arrays)
    if (!isNaN(part)) part = parseInt(part, 10);
    return acc[part];
  }, obj);
}

export function parseDynamicValue(value) {
  if (typeof value !== 'string') return value; // already parsed
  try {
     if (/^-?\d+(\.\d+)?$/.test(value.trim())) {
      // It's a number-like string, preserve it as string to keep formatting
      return value;
    }
    // Try JSON.parse
    const parsed = JSON.parse(value);
    // If it's still a string (e.g. "\"19:20\""), remove extra quotes
    if (typeof parsed === 'string') {
      return parsed;
    }
    return parsed; // could be array/object/number/etc
  } catch (e) {
    // Not JSON, return as is
    return value;
  }
}

export const filteredFormValues = (transformedFormValues) => {
   return Object.fromEntries(
  Object.entries(transformedFormValues).filter(([, val]) => {
    return !(
      val === "" ||
      val === null);
  })
)
}

function toTitleCase(str) {
    return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\w\S*/g, (txt) => 
            txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        ); // Capitalize each word
}


export function combineLabelTitle(label, path) {
  const parts = path.split('.'); // split by dot
  if(parts?.length > 1){
  return toTitleCase(parts?.[0])+' →'+label
  }
  return label
}

export const  firstLetterShouldCapital = (string) => {
     return string?.split(' ').map(n => n[0]).join('').toUpperCase() || ''
}

export const formatPathName = (path) => {
  if(!path) return
  if(path && Array.isArray(path))
    path = path?.[0]?.path
  let parts = path.split("/").filter(Boolean);
  if (parts[0]?.toLowerCase() === "bmr") {
    parts.shift();
  }
let lastPart = parts.pop() || "";
if(!isNaN(lastPart)){
  lastPart = parts?.shift() || ''
}
  if (lastPart.toLowerCase() === "qa") return "Quality Approval";
  if (lastPart.toLowerCase() === "lsm") return "QR Code Generation";
  if (lastPart.toLowerCase() === "qc") return "Quality Control";  
   return lastPart
    .split("-")
    .map(word => {
      if (word.toLowerCase() === "lsm") return "LSM"; // force uppercase
      if (word.toLowerCase() === "bmr") return "BMR"; // force uppercase
      if (word.toLowerCase() === "manufacturer_view") return "Manufacturer View"; // force uppercase
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export const findSlugString = (slug) => {
  const match = slug?.match(/(\d+)(.*)/);
  if (!match) return null;

  return match[2]
    .replace(/^-/, "")
    .replace(/^-/, "")

}

export const truncateText = (text, limit = 25) => {
    if (!text) return "-";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
};


 export const getLastIdFromUrl = (url) => {
  const parts = url?.split('/');
  return parts?.[parts?.length - 1];
};

export const cleanPayload = (obj) => {
  return Object.fromEntries(
    // eslint-disable-next-line no-unused-vars
    Object.entries(obj).filter(([__, v]) => 
      v !== null && 
      v !== undefined && 
      v !== "" && 
      !(Array.isArray(v) && v.length === 0)
    )
  );
};

export const getTooltipTextButton = (submitRequest, cycleLengthIssue, isTerminated, noTermination, isInActive, label) => {

  if (submitRequest) {
    return "Change Request already submitted";
  }
  
  if (isTerminated) {
    return "The Cycle is terminated";
  }
  if (isInActive) {
    return "This cycle is In-active";
  }
   if(noTermination){
     return "Change Request should be active when Cycle is terminating";
 }
 if (cycleLengthIssue) {
    return "The active pool cycle count is insufficient";
  }
  return label;
};

export const normalizeEmptyToNull = (item) =>{
     return Object.fromEntries(
        Object.entries(item).map(([key, value]) => [
          key,
          value === "" ? null : value,
        ])
      );
}


export const getNextCycleName = (cyclesData = []) => {
  if (!cyclesData.length) return "Cycle 1";

  const cycleNumbers = cyclesData
    .map(item => {
      const match = item?.cycle?.match(/\d+/);
      return match ? Number(match[0]) : null;
    })
    .filter(num => num !== null);

  const maxCycle = cycleNumbers.length ? Math.max(...cycleNumbers) : 0;

  return `Cycle ${maxCycle + 1}`;
};

export const formattedSampleVal = (field_value) => {
  if (!field_value) return '';

  // Normalize input → array
  const valuesArray = Array.isArray(field_value)
    ? field_value
    : typeof field_value === 'string'
      ? field_value.split(',')
      : [];

  return valuesArray
    .map(item =>
      item
        .trim()
        .split('_')
        .map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(' ')
    )
    .join(', ');
};

//Created Helper function to show or hide the units in COA form. Show unit only if value is a number (positive, negative, or decimal)
// Helper function to get subLabel based on field value
export const getSubLabel = (formik, fieldName, unit) => {
    const value = formik?.values?.[fieldName];
    if (!value) return null;
    const stringValue = String(value).trim();
    // Check if value is a number (positive, negative, or decimal)
    const isNumber = !isNaN(parseFloat(stringValue)) && isFinite(stringValue);
    // Show unit only if it's a number (including negative or decimal)
    return isNumber ? unit : null;
}

// Helper function to get unit for print view - returns unit only if value is a number (positive, negative, or decimal)
export const getPrintUnit = (value, unit) => {
    if (!value) return '';
    const stringValue = String(value).trim();
    // Check if value is a number (positive, negative, or decimal)
    const isNumber = !isNaN(parseFloat(stringValue)) && isFinite(stringValue);
    // Show unit only if it's a number (including negative or decimal)
    return isNumber ? unit : '';
};

export const getLabelValue = (arrData,value) => {
  if(!arrData?.length) return;
    const option = arrData?.find(option => option?.value == value);
    return option ? option?.label : null;
};